// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alphabetNavigationStyles } from "@bg/Overrides/Widgets/Brand/AlphabetNavigation";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

alphabetNavigationStyles.allButton = {
    css: css`
        height: 40px;
        width: 53px;
        padding: 5px 12px;
        margin-top: 8px;
        margin-left: 8px;
        span {
            font-size: ${fontConfig.fontSize.regular}px;
        }
    `,
};
